import update from 'immutability-helper';
import get from 'lodash/get';
import * as ACTIONS from '../actions';
import { DEFAULT_DRAWER_STATE, DEFAULT_SUMMARY_DRAWER_STATE } from '../constants';

const drawerReducer = (state = DEFAULT_DRAWER_STATE, action) => {
  // Ensure we always have a valid state
  const currentState = state || DEFAULT_DRAWER_STATE;
  
  switch (action.type) {
    case ACTIONS.SHOW:
      return update(currentState, {
        data: { $set: get(action, 'payload.data') ? get(action, 'payload.data') : DEFAULT_DRAWER_STATE.data },
        show: { $set: true },
      });

    case ACTIONS.CLOSE:
      return update(currentState, {
        data: { $set: DEFAULT_DRAWER_STATE.data },
        show: { $set: false },
      });

    case ACTIONS.CREATE.SUCCESS:
    case ACTIONS.BATCH.SUCCESS:
    case ACTIONS.SAVE.SUCCESS:
    case ACTIONS.DELETE.SUCCESS:
      return update(currentState, {
        data: { $set: DEFAULT_DRAWER_STATE.data },
        show: { $set: false },
      });

    default:
      return currentState;
  }
};

var parseAdditionalData = function(lead) {
  if (!lead) return lead;
  return Object.assign({}, lead, {
    additional_data: typeof lead.additional_data === 'string'
      ? JSON.parse(lead.additional_data)
      : lead.additional_data
  });
};

const summaryDrawerReducer = (state = DEFAULT_SUMMARY_DRAWER_STATE, action) => {
  // Ensure we always have a valid state
  const currentState = state || DEFAULT_SUMMARY_DRAWER_STATE;

  switch (action.type) {
    case ACTIONS.SHOW_SUMMARY_DRAWER:
      return update(currentState, {
        summaryData: { $set: get(action, 'payload.summaryData') },
        leads: { $set: [] },
        show: { $set: true },
        isLoading: { $set: true },
      });

    case ACTIONS.LOAD_SUMMARY_CARD_LEADS.INIT:
      return update(currentState, {
        isLoading: { $set: true },
      });

    case ACTIONS.LOAD_SUMMARY_CARD_LEADS.SUCCESS:
      var leadsData = get(action, 'payload.data.data', []);
      return update(currentState, {
        leads: { $set: leadsData.map(parseAdditionalData) },
        isLoading: { $set: false },
      });

    case ACTIONS.LOAD_SUMMARY_CARD_LEADS.FAIL:
      return update(currentState, {
        leads: { $set: [] },
        isLoading: { $set: false },
      });

    case ACTIONS.CLOSE_SUMMARY_DRAWER:
      return update(currentState, {
        summaryData: { $set: DEFAULT_SUMMARY_DRAWER_STATE.summaryData },
        leads: { $set: DEFAULT_SUMMARY_DRAWER_STATE.leads },
        show: { $set: false },
        isLoading: { $set: false },
      });

    default:
      return currentState;
  }
};

export { drawerReducer, summaryDrawerReducer }; 